<div class="yes-no"  [ngClass]="invalid && !_value ? 'error-color' : 'normal-color'">
  <label class="cell small-12 medium-12 large-12 question-label" attr.aria-label="{{label}}">{{label}}</label>
  <div class="radio-buttons">
    <div class="score-div cell shrink">
      <mat-radio-group>
        <mat-radio-button (change)="radioSelected($event)" value="true">{{'yes' | translate}}</mat-radio-button>
        <mat-radio-button (change)="radioSelected($event)" value="false">{{'no' | translate}}</mat-radio-button>
      </mat-radio-group>
    </div>
  </div>
</div>
